import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { createGradientOrSolid } from 'utils';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  width: 100%;
  border-radius: 4px;

  0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 2px 3px rgba(255, 255, 255, 0.30);
` as any;

export const StyledBundlePrice = styled.div`
  margin-top: 8px;
  font-family: ${({ fontFamily }: any) => fontFamily};
  background: ${({ bundleButtonColor }: any) =>
    bundleButtonColor && createGradientOrSolid(bundleButtonColor)};
  height: 31px;
  border-radius: 4px;
  border-bottom: 1px solid #31d9f8;
  box-shadow: 0px -1px 4.3px 0px #14fd29 inset;
  display: flex;
  direction: ltr;
  justify-content: center;
  align-items: center;
  color: ${({ bundleButtonTextColor }: any) => bundleButtonTextColor};
  position: relative;

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;
    width: 100%;

    span,
    .final-price,
    .stroked {
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3),
        -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),
        -0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43);
    }

    .stroked {
      font-size: 0.75em;
    }

    @media (width < ${breakpoints.mobileS}) {
      font-size: 12px;
    }
  }
` as any;
